import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { warehouseexecApi, type WarehouseWorker } from '../../api/warehouseexec';

export function WorkerDashboardPage() {
  const [workers, setWorkers] = useState<WarehouseWorker[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    void warehouseexecApi.workers().then(setWorkers).catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/warehouse" className="text-sm text-slate-600 hover:underline">← Warehouse hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Worker dashboard</h1>
      {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
      <div className="mt-6 overflow-x-auto rounded-xl border">
        <table className="min-w-full text-left text-sm">
          <thead className="bg-slate-50">
            <tr>
              <th className="p-3">Code</th>
              <th className="p-3">Name</th>
              <th className="p-3">Active</th>
              <th className="p-3">Productivity</th>
            </tr>
          </thead>
          <tbody>
            {workers.map((w) => (
              <tr key={w.id} className="border-t">
                <td className="p-3">{w.code}</td>
                <td className="p-3">{w.name}</td>
                <td className="p-3">{w.active ? 'Yes' : 'No'}</td>
                <td className="p-3">{w.productivity.toFixed(2)}</td>
              </tr>
            ))}
            {!workers.length && <tr><td colSpan={4} className="p-6 text-slate-500">No workers</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
